import {
    EventEmitter,
    HostListener,
    Input,    Output,} from '@angular/core';

/**
 * Base class for all components which hold common properties
 * This includes state settings such as visibility and enabling
 */
export abstract class Common {
    // io
    @Input() tooltip: string;

    // event emitters
    @Output() onClick: EventEmitter<any> = new EventEmitter<any>();

    @HostListener('click') onMouseClick(): void {
        this.onClick.emit();
    }
}



// WEBPACK FOOTER //
// ./client-src/app/core/baseObjects/common.ts